module.exports = __webpack_public_path__ + "static/media/miaosha.8516f036.svg";